// Modify header & footer pdf
// Components
import { BaseTable, Card, FooterMenu, HeaderMenu, Loading } from "components"
import { Create, PdfLinkAccount } from "./components"

// Contexts
import { SuccessContext } from "contexts"

// Utils
import { convertNumber, exportPdf } from "utils"
import { ItemContext, useAllCoaList, useListAccount } from "./utils"

export default function LinkAccountDashboard(): JSX.Element {
  // Hooks
  const coa = useAllCoaList()
  const { data, isLoading, refetch } = useListAccount()

  return (
    <section className="container pt-5  gap-5 flex flex-col">
      <HeaderMenu title="DASHBOARD LINK ACCOUNT" />

      <Card>
        <Card.Body>
          {isLoading || !data.length ? (
            <Loading
              loading={isLoading}
              errorText="No data available"
            />
          ) : (
            <SuccessContext.Provider value={refetch}>
              <BaseTable>
                <thead>
                  <tr>
                    <th className="border">COMPONENT CODE</th>
                    <th className="border">COMPONENT NAME</th>
                    <th className="border" colSpan={2}>DESCRIPTION</th>
                    <th className="border">NUMBER</th>
                    <th className="border">COA NAME</th>
                    <th className="border">BALANCE</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="border w-[100px]">{item.dashboard_link_code}</td>
                        <td className="border w-[300px]">{item.dashboard_link_name}</td>
                        <td className="border w-[300px]">{item.description}</td>

                        <td className="border text-center w-[100px]">
                          <ItemContext.Provider value={item}>
                            <Create />
                          </ItemContext.Provider>
                        </td>

                        <td className="border w-[200px]">
                          {item.datacoa.map((item, key) => (
                            <div
                              key={key}
                              className="whitespace-nowrap"
                            >
                              {item.coa_code}
                            </div>
                          ))}
                        </td>

                        <td className="border w-[200px]">
                          {item.datacoa.map((item, key) => (
                            <div
                              key={key}
                              className="whitespace-nowrap"
                            >
                              {item.coa_name}
                            </div>
                          ))}
                        </td>

                        <td className="border w-[200px]">
                          {item.datacoa.map((item, key) => (
                            <div
                              key={key}
                              className="whitespace-nowrap text-right"
                            >
                              {!coa.isLoading && convertNumber(coa.getOpeningBalance(item.coa_id)).intoCurrency}
                            </div>
                          ))}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </BaseTable>
            </SuccessContext.Provider>
          )}
        </Card.Body>
      </Card>

      <FooterMenu
        pdf={{
          actiontype: "pdf",
          loading: coa.isLoading || isLoading ? "true" : undefined,
          onClick: () => {
            exportPdf({
              fileName: "Link Account Dashboard",
              documentComponent: (
                <PdfLinkAccount
                  coa={coa}
                  dataList={data}
                  title="Link Account Dashboard"
                />
              ),
            })
          }
        }}
      />
    </section>
  )
}